import { isApiErrorResponse } from 'shared';

import { showSnackbar } from './snackbar';

export async function wrapRequest<T>(
  request: Promise<T>,
  {
    successMessage,
    errorMessage,
    showSuccessMessage = true,
    showErrorMessage = true
  }: {
    successMessage?: string;
    errorMessage?: string;
    showSuccessMessage?: boolean;
    showErrorMessage?: boolean;
  } = {}
) {
  try {
    const response = await request;
    if (showSuccessMessage) {
      showSnackbar({
        message: successMessage
      });
    }

    return response;
  } catch (error) {
    let message: string | undefined;

    if (errorMessage) {
      message = errorMessage;
    } else if (isApiErrorResponse(error)) {
      message = error.message;
    }

    if (showErrorMessage) {
      showSnackbar({
        message,
        negative: true
      });
    }

    throw error;
  }
}
